/* eslint-disable no-undef */
import React, { useState } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye, faHandWave } from '@fortawesome/pro-regular-svg-icons';
import H2 from './H2';
import Paragraph from './Paragraph';
import { useCallback, useEffect } from 'react';

function MapContainer({ trip }) {
  const [activeMarker, setActiveMarker] = useState(null);
  const [markers, setMarkers] = useState([]);

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const setupMarkers = useCallback(() => {
    const list = [];
    if (trip?.attributes) {
      list.push({
        id: 1,
        name: trip?.attributes?.start_location_name,
        position: {
          lat: Number(trip?.attributes?.start_location_lat),
          lng: Number(trip?.attributes?.start_location_long),
        },
      });

      list.push({
        id: 2,
        name: trip?.attributes?.end_location_name,
        position: {
          lat: Number(trip?.attributes?.end_location_lat),
          lng: Number(trip?.attributes?.end_location_long),
        },
      });
    }
    setMarkers(list);
  }, [trip]);
  const handleOnLoad = (map) => {
    const bounds = new google.maps.LatLngBounds();
    markers.forEach(({ position }) => bounds.extend(position));
    map.fitBounds(bounds);
  };

  useEffect(() => {
    setupMarkers();
  }, [setupMarkers]);

  return (
    <div className="relative mt-8 overflow-x-hidden border-t border-solid border-dark-100">
      <H2 text="Start & closing location" className="pb-[24px] pt-16 xl:pb-8" />
      <div className="h-[9.5rem] xl:h-[35.9375rem] xl:w-full  ">
        <LoadScript googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY}>
          {markers && markers.length ? (
            <GoogleMap
              onLoad={handleOnLoad}
              onClick={() => setActiveMarker(null)}
              mapContainerStyle={{ width: '100%', height: '100%' }}
            >
              {markers.map(({ id, name, position }) => (
                <Marker key={id} position={position} onClick={() => handleActiveMarker(id)}>
                  {activeMarker === id ? (
                    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                      <div>{name}</div>
                    </InfoWindow>
                  ) : null}
                </Marker>
              ))}
            </GoogleMap>
          ) : null}
        </LoadScript>
      </div>

      <div className="relative mt-8 flex">
        <div className="">
          <span className="inline-block">
            <FontAwesomeIcon icon={faBullseye} className="text-xs leading-[16.8px] text-dark-600" />
          </span>
          <span className="ml-2 inline-block">
            <Paragraph text="Meeting point" className=" font-semibold text-dark-500" />
          </span>
          <div className="mx-5 w-[9.6rem] pt-[6.5px] font-sans text-lg leading-[25.2px] text-dark-800 underline md:w-full">
            <a href={trip?.attributes?.start_location_gm_link} target="_blank" rel="noreferrer">
              {trip?.attributes?.start_location_name}
            </a>
          </div>
        </div>
        <div className="md:ml-[103px]">
          <span className="inline-block">
            <FontAwesomeIcon
              icon={faHandWave}
              className="h-[17px] w-3 text-xs leading-[16.8px] text-dark-600"
            />
          </span>
          <span className="ml-2 inline-block">
            <Paragraph text="Closing location" className=" font-semibold text-dark-500" />
          </span>
          <div className="mx-5 w-[9.6rem] pt-[6.5px] font-sans text-lg leading-[25.2px] text-dark-800 underline md:w-full">
            <a href={trip?.attributes?.end_location_gm_link} target="_blank" rel="noreferrer">
              {trip?.attributes?.end_location_name}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MapContainer;
